import {ComponentProps} from '../types';
import React from 'react';

const Arrow = ({...props}: ComponentProps) => (
  <svg style={{ width: 24, height: 24, marginRight: 12 }} viewBox="0 0 24 24">
    <path fill="currentColor" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
  </svg>
);

export default Arrow;